import { Organization } from "../organizations/types";
import { RootDispatch, RootGetState } from "../types";
import flash from "../flash/actions";
import { getLocations, getPatientList } from "../dashboard/actions";
import { subscribeChannels, unsubscribeAllChannels } from "../pubnub/actions";
import { get } from "../../utils/fetch";

export type Action =
  | { type: "organizations/getOrganizations-started" }
  | { type: "organizations/getOrganizations-success"; orgs: Organization[] }
  | { type: "organizations/getOrganizations-failure"; errorMessage: string }
  | { type: "organizations/setOrganization"; org: Organization }
  | { type: "organizations/clearOrganization" };

export const fetchOrgs = () => async (dispatch: RootDispatch) => {
  const url = "/api/organization/";

  const resp = await get<Organization[]>(url);

  if (resp.error) {
    dispatch({
      type: "organizations/getOrganizations-failure",
      errorMessage: resp.error.message
    });
    dispatch(flash("Could not get orgs for user.", "error"));
  } else if (resp.data) {
    dispatch({
      type: "organizations/getOrganizations-success",
      orgs: resp.data
    });
    if (resp.data.length === 1) {
      dispatch(setCurrentOrg(resp.data[0]));
    }
  }
};

export const setCurrentOrg = (org: Organization) => async (
  dispatch: RootDispatch,
  getState: RootGetState
) => {
  dispatch({ type: "organizations/setOrganization", org });
  dispatch(getPatientList());
  dispatch(getLocations());
  dispatch(unsubscribeAllChannels());
  dispatch(subscribeChannels([`${org.id}.${getState().session.data.currentUser?.id}`]));
};

export const clearCurrentOrg = () => async (dispatch: RootDispatch) => {
  dispatch({ type: "organizations/clearOrganization" });
};
